export default "__VITE_ASSET__11938c3b__"